// One import seam for the whole app: components take their i18n hooks from
// "@/i18n", never from the library directly, so swapping use-intl for
// next-intl (same API) later touches only this folder.
export { useLocale } from "use-intl";
export { useTranslations } from "./use-live-translations";
export { useIntlLocale, useLocaleSwitcher } from "./I18nProvider";
export { useTerms } from "./use-terms";
export * from "./config";
